exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.lxm-login-reg-source-tip[data-v-6a8cb798] {\n  margin-bottom: 1.43rem;\n}\n", "", {"version":3,"sources":["/./src/components/Login/common/src/components/Login/common/RegSourceTip.vue","/./src/components/Login/common/RegSourceTip.vue"],"names":[],"mappings":";AASA;EACE,uBAAA;CCRD","file":"RegSourceTip.vue","sourcesContent":["\n\n\n\n\n\n\n\n@import '../../styles/index.styl'\n.lxm-login-reg-source-tip\n  margin-bottom: spacing-big\n",".lxm-login-reg-source-tip {\n  margin-bottom: 1.43rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-6a8cb798&scoped=true!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login/common/RegSourceTip.vue
// module id = 642
// module chunks = 0